import React, { useMemo } from 'react';
import { mainColor } from '@/pages/product-manager/sale-plan/components/sales-plan-drawer/data.js';
import { Chart, registerShape, Geom, Axis, Tooltip, Interval, Interaction, Coordinate, Legend } from 'bizcharts';
import { Empty, Table, Tooltip as ToolTips } from '@drip/drip-design';
import './index.less';
import { thousands } from '@/common/utils';

function ItemBlock({ data, index }) {
  if (!data) return null;
  return (
    <div className={'chart-item' + '-' + index}>
      <div className="item-name">
        {index == 1 && <span className="round" style={{ background: mainColor[index] }} />}
        <ToolTips title={data.type}>
          <span className="ellipsis-1-line">{data.type}</span>
        </ToolTips>
        {index == 0 && <span className="round" style={{ background: mainColor[index] }} />}
      </div>
      <span className="item-desc">目标成交金额</span>
      <div className="item-num">￥{thousands(data.value)}</div>
      <span className="item-desc">达成率</span>
      <div className="item-num">{data.completeRate}</div>
    </div>
  );
}

function Charts({ levelPlan }) {
  const data = useMemo(() => {
    if (!levelPlan) return [];
    return levelPlan.map((item, index) => {
      const { amount, name, completeRate } = item;
      return {
        index: index,
        type: name || '',
        value: Number(amount),
        completeRate,
      };
    });
  }, [levelPlan]);

  const columns = [
    {
      title: '名称',
      dataIndex: 'type',
      render(record, _, index) {
        return (
          <ToolTips title={record}>
            <span className="ellipsis-1-line">
              <span className="round" style={{ background: mainColor[index + 2] }} />
              {record}
            </span>
          </ToolTips>
        );
      },
    },
    {
      title: '目标成交金额',
      dataIndex: 'value',
      render(record) {
        return thousands(record);
      },
    },
    {
      title: '达成率',
      dataIndex: 'completeRate',
      render(record) {
        return record;
      },
    },
  ];

  return (
    <>
      <div className="chart-left">
        <ItemBlock data={data[0]} index={0} />
        <Chart data={data} height={174} width={174} autoFit>
          <Coordinate type="theta" radius={1} innerRadius={0.68} />
          <Axis visible={false} />
          <Tooltip visible={false} />
          <Interval adjust="stack" position="value" color={['index', (x) => mainColor[x]]} />
          <Legend visible={false} />
        </Chart>
        <ItemBlock data={data[1]} index={1} />
      </div>
      <div className="chart-right">
        {data.length > 2 ? (
          <Table columns={columns} size="small" dataSource={data.slice(2)} scroll={{ y: 170 }} pagination={false} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无其他计划" />
        )}
      </div>
    </>
  );
}

export default Charts;
